module.exports = __webpack_public_path__ + "static/media/boat.1689c93a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/boat.svg
// module id = 530
// module chunks = 0